import { STATUS_OPTIONS } from "../StatusChipSelector";

const POTENTIAL_LABELS = { 1: "Baixo", 2: "Médio", 3: "Alto" };

const HIGH_RISK_STATUS = new Set([2, 4, 5]);

function statusLabel(code) {
  const n = Number(code);
  return STATUS_OPTIONS.find((s) => s.value === n)?.label ?? String(code);
}

function findName(list, id) {
  if (id == null || id === "") return null;
  const row = (list || []).find((x) => String(x.id) === String(id));
  return row?.nome || row?.name || null;
}

function assigneeLabel(value, { usersList, agentsList }) {
  if (value === "queue") return "Fila (sem atribuição)";
  if (typeof value === "string" && value.startsWith("user:")) {
    const id = value.slice(5);
    const u = usersList.find((x) => String(x.id) === String(id));
    return u?.nome || u?.name || `Usuário #${id}`;
  }
  if (typeof value === "string" && value.startsWith("agent:")) {
    const id = value.slice(6);
    const a = agentsList.find((x) => String(x.id ?? x.id_agente ?? x.agentId) === String(id));
    return a?.name || a?.nome || `Agente ${id}`;
  }
  return String(value);
}

/**
 * Gera linhas legíveis + avisos para a etapa de confirmação.
 */
export function buildBulkChangeSummary({
  form,
  replaceTags,
  tags,
  companies,
  channels,
  typesFlat,
  usersList,
  agentsList,
}) {
  const lines = [];
  const warnings = [];

  if (form.status !== "") {
    const label = statusLabel(form.status);
    lines.push({
      label: "Status",
      value: label,
      severity: HIGH_RISK_STATUS.has(Number(form.status)) ? "warning" : undefined,
    });
    if (HIGH_RISK_STATUS.has(Number(form.status))) {
      warnings.push(`O status "${label}" encerra ou arquiva solicitações — verifique se é isso mesmo.`);
    }
    if (Number(form.status) === 3 && form.nextContactAt?.trim()) {
      lines.push({ label: "Próximo contato", value: form.nextContactAt.replace("T", " ") });
    }
  }

  if (replaceTags) {
    const tagStr = tags?.length ? tags.join(", ") : "(nenhuma — remove todas as tags)";
    lines.push({ label: "Tags", value: `Substituir por: ${tagStr}`, severity: "warning" });
    warnings.push("As tags atuais serão substituídas em todas as solicitações selecionadas.");
  }

  if (form.projectId !== "") {
    const name = findName(companies, form.projectId) || `#${form.projectId}`;
    lines.push({ label: "Empresa", value: name, severity: "warning" });
    warnings.push(
      "Trocar a empresa com solicitação em aberto: a próxima mensagem do cliente no WhatsApp pode abrir uma solicitação nova no projeto do canal, e esta pode ficar para trás."
    );
  }

  if (form.channelId !== "") {
    lines.push({ label: "Canal", value: findName(channels, form.channelId) || `#${form.channelId}` });
  }

  if (form.typeId !== "") {
    lines.push({ label: "Tipo", value: findName(typesFlat, form.typeId) || `#${form.typeId}` });
  }
  if (form.subtype1 !== "") {
    lines.push({ label: "Subtipo 1", value: findName(typesFlat, form.subtype1) || `#${form.subtype1}` });
  }
  if (form.subtype2 !== "") {
    lines.push({ label: "Subtipo 2", value: findName(typesFlat, form.subtype2) || `#${form.subtype2}` });
  }
  if (form.subtype3 !== "") {
    lines.push({ label: "Subtipo 3", value: findName(typesFlat, form.subtype3) || `#${form.subtype3}` });
  }

  if (form.assignee !== "") {
    lines.push({
      label: "Responsável",
      value: assigneeLabel(form.assignee, { usersList, agentsList }),
    });
  }

  if (form.potential !== "") {
    lines.push({ label: "Potencial", value: POTENTIAL_LABELS[form.potential] || form.potential });
  }

  if (form.nf?.trim()) lines.push({ label: "NF", value: form.nf.trim() });
  if (form.produto?.trim()) lines.push({ label: "Produto", value: form.produto.trim() });
  if (form.campanha?.trim()) lines.push({ label: "Campanha", value: form.campanha.trim() });
  if (form.textoAdicional?.trim()) lines.push({ label: "Campo adicional", value: form.textoAdicional.trim() });

  return { lines, warnings: [...new Set(warnings)] };
}
